class SupportController {
  /* @ngInject */
  constructor($state, $http, Session, SETTINGS) {
    this.$state = $state;
    this.$http = $http;
    this.Session = Session;
    this.SETTINGS = SETTINGS;
  }

  $onInit() {
    this.user = this.Session.read('userinfo');
    this.engagementManager = {};

    this
      .$http
      .get(`/organizations/${this.user.organization_id}`, {
        params: { fl: 'EngagementManager' },
      })
      .then(({ data: { EngagementManager } }) => {
        this.engagementManager = EngagementManager;
      });
  }
}

export default SupportController;



// WEBPACK FOOTER //
// ./client/app/settings/support/support.controller.js